/* eslint-disable import/prefer-default-export */

import RootElement from "./root-element";

export const wrapRootElement = RootElement;
